var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKakaoSettingWaitingPreviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1707481404"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.97021 12.1938V14.45C2.07953 15.1725 2.52245 16.3222 3.33198 17.2886C4.14615 18.2605 5.25846 18.968 6.69923 18.968H7.68444V40.4519H9.65487V18.968H10.6401C12.0809 18.968 13.1932 18.2605 14.0073 17.2886C14.8169 16.3222 15.2598 15.1725 15.3691 14.45V12.1938H12.0194V13.3551H10.049V12.1938H7.29036V13.3551H5.31994V12.1938H1.97021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.0249 8.32264C25.0249 4.79515 27.936 1.93555 31.5273 1.93555C35.1186 1.93555 38.0297 4.79515 38.0297 8.32264V14.4504C37.9194 15.197 37.5107 16.3506 36.7505 17.3081C35.9879 18.2681 34.9306 18.9678 33.4977 18.9678H32.5125V40.4517H30.5421V18.9678H29.5569C28.124 18.9678 27.0667 18.2681 26.3041 17.3081C25.5439 16.3506 25.1352 15.197 25.0249 14.4504V8.32264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4827 20.8253C36.1721 20.552 37.4344 19.5933 38.3037 18.4984C39.3165 17.2229 39.8529 15.7022 39.992 14.6396L39.9998 14.5781V7.93548H39.9908C39.7851 3.51875 36.0744 0 31.527 0C26.9797 0 23.2691 3.51875 23.0632 7.93548H23.0542V14.5781L23.0622 14.6396C23.2014 15.7022 23.7374 17.2229 24.7503 18.4984C25.6197 19.5933 26.8819 20.552 28.5714 20.8253V42H34.4827V20.8253ZM25.0246 8.32258C25.0246 4.79508 27.9357 1.93548 31.527 1.93548C35.1183 1.93548 38.0294 4.79508 38.0294 8.32258V14.4504C37.9191 15.197 37.5104 16.3505 36.7502 17.308C35.9877 18.268 34.9303 18.9677 33.4974 18.9677H32.5122V40.4516H30.5418V18.9677H29.5566C28.1237 18.9677 27.0664 18.268 26.3038 17.308C25.5436 16.3505 25.135 15.197 25.0246 14.4504V8.32258Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.97042 1.35498V14.4498C2.07974 15.1723 2.52266 16.3221 3.33219 17.2885C4.14636 18.2604 5.25867 18.9679 6.69944 18.9679H7.68466V40.4518H9.65508V18.9679H10.6403C12.0811 18.9679 13.1934 18.2604 14.0076 17.2885C14.8171 16.3221 15.26 15.1723 15.3693 14.4498V1.35498H17.3397V14.5782L17.3317 14.6397C17.1892 15.7282 16.5895 17.2524 15.5291 18.5183C14.6204 19.603 13.321 20.5546 11.6255 20.8261V42.0001H5.71423V20.8261C4.01876 20.5546 2.71938 19.603 1.81066 18.5183C0.75022 17.2524 0.150541 15.7282 0.00803973 14.6397L0 14.5782V1.35498H1.97042Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.32031 1.74219V13.3551H7.29074V1.74219H5.32031Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10.0493 1.74219V13.3551H12.0197V1.74219H10.0493Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M7.68555 35.4194H9.65597V40.4517H7.68555V35.4194Z",
    fill: "#FFE500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M30.5415 35.4194H32.5119V40.4517H30.5415V35.4194Z",
    fill: "#FFE500"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakaoSettingWaitingPreviewIcon);
export default __webpack_public_path__ + "static/media/kakao_setting_waiting_preview_icon.c79b382c4eb834e8f83800151903e7a6.svg";
export { ForwardRef as ReactComponent };